class RecentlyViewed {
  constructor(container) {
    this.container = container;
    this.productGrid = container.querySelector('[data-products-grid]');
    this.storage = window.localStorage;
    this.limit = parseInt(container.dataset.productsLimit, 10) || 8;
    this.cardSectionId = 'product-card-ajax';
    this.root = window.Shopify?.routes?.root || '/';

    if (this.productGrid) {
      this.fetchAndRenderProducts();
    }
  }

  getViewedProducts() {
    const viewed = this.storage.getItem('recentlyViewed');
    if (!viewed) return [];

    try {
      return JSON.parse(viewed);
    } catch (error) {
      return [];
    }
  }

  normalizeViewedProducts(products) {
    return products
      .map((item) => {
        if (item?.handle) {
          return { id: item.id, handle: item.handle };
        }

        if (item?.content) {
          const match = item.content.match(/href="\/products\/([^"?#]+)/);
          if (match) {
            return { id: item.id, handle: match[1] };
          }
        }

        return null;
      })
      .filter(Boolean);
  }

  extractCardHtml(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const card = doc.querySelector('.grid-item');
    return card ? card.outerHTML : '';
  }

  async fetchCardHtml(handle) {
    const response = await fetch(`${this.root}products/${handle}?section_id=${this.cardSectionId}`);
    if (!response.ok) return '';

    const html = await response.text();
    return this.extractCardHtml(html);
  }

  initScrollButtons() {
    const grid = this.container.querySelector('.scroll-grid');
    if (!grid) return;

    const gridId = grid.id;
    const leftButton = this.container.querySelector('.scroll-left[data-grid="' + gridId + '"]');
    const rightButton = this.container.querySelector('.scroll-right[data-grid="' + gridId + '"]');
    const scrollAmount = 296;

    if (leftButton && !leftButton.dataset.initialized) {
      leftButton.dataset.initialized = 'true';
      leftButton.addEventListener('click', function () {
        grid.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
    }

    if (rightButton && !rightButton.dataset.initialized) {
      rightButton.dataset.initialized = 'true';
      rightButton.addEventListener('click', function () {
        grid.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }
  }

  async fetchAndRenderProducts() {
    const viewedProducts = this.normalizeViewedProducts(this.getViewedProducts()).slice(0, this.limit);
    if (viewedProducts.length === 0) return;

    this.container.classList.remove('dn');

    const cards = await Promise.all(
      viewedProducts.map((item) => this.fetchCardHtml(item.handle))
    );

    const cardHtml = cards.filter(Boolean).join('');
    if (!cardHtml) return;

    this.productGrid.innerHTML = cardHtml;
    this.initScrollButtons();
  }
}

function initRecentlyViewed() {
  document.querySelectorAll('[data-recently-viewed]').forEach(function (container) {
    if (container.dataset.initialized === 'true') return;
    container.dataset.initialized = 'true';
    new RecentlyViewed(container);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRecentlyViewed);
} else {
  initRecentlyViewed();
}

document.addEventListener('shopify:section:load', function () {
  initRecentlyViewed();
});
